import React, { useState } from 'react'
import useQuery from 'shared/hooks/useQuery'
import DefaultAvatar from 'assets/images/profile-thumbnail.svg'
import styled from 'styled-components'
import Box from 'shared/components/Box'
import ProtectedImage from 'shared/components/ProtectedImage'
// import { ParticipantType } from 'pages/Participants/model/participant'

interface ParticipantAvatarProps {
  alt: string
  row: {
    photo_url?: string | null
    image_link?: string | null
  }
  width?: string
  height?: string
}

const ParticipantAvatar: React.FC<ParticipantAvatarProps> = (props: ParticipantAvatarProps) => {
  const { row, width, height } = props
  return (
    <ParticipantAvatarContainer $width={width} $height={height}>
      <ProtectedImage
        alt={props.alt}
        src={row.image_link ? '' : row.photo_url || ''}
        defaultSrc={row.image_link ? row.image_link : DefaultAvatar}
      />
    </ParticipantAvatarContainer>
  )
}

const ParticipantAvatarContainer = styled(Box)<{ $width?: string; $height?: string }>`
  width: ${({ $width }) => $width ?? '50px'};
  height: ${({ $height }) => $height ?? '50px'};
  border-radius: 5px;
  overflow: hidden;

  img {
    max-width: 100%;
  }
`

export default ParticipantAvatar
